import React, { FC } from "react";
import MaterialListItemIcon, { ListItemIconProps } from "@mui/material/ListItemIcon";

export const ListItemIcon: FC<ListItemIconProps> = props => (
  <MaterialListItemIcon {...props as any} />
);
